<div class="crud-page">
  <div class="crud-content">
    <div class="container py-3 py-lg-4">
      <div class="row">
        <div class="col-12 px-0">
          <app-crud-header
            title="Campaigns"
            name="Campaign"
            [createRoute]="crudRoute"
            [breadcrumb]="false"
          ></app-crud-header>
        </div>

        <app-alert [content]="alertData"></app-alert>

        @if (initialized()) { @for (item of data.rows; track $index) {
        <div class="col-md-6 col-xl-4 mb-3 mb-md-4" @fadeIn>
          <app-main-card
            [image]="item.image"
            [primary]="canShow() ? 'arrow_forward_ios' : ''"
            [secondary]="canEdit() ? 'edit' : ''"
            [extra]="canDelete() ? 'delete' : ''"
            (onPrimary)="onPrimary(item.id)"
            (onSecondary)="onSecondary(item.id)"
            (onExtra)="deleteModal(item.id)"
          >
            <div class="row py-3">
              <div class="col-12">
                <p class="mb-0">
                  <i class="fa-solid fa-folder icon-w"></i
                  ><span class="fw-bold">{{ item.name }}</span>
                </p>
              </div>
            </div>
          </app-main-card>
        </div>
        } @empty {
        <div class="col-12" @fadeIn>
          <p class="h4 text-secondary">No campaigns found</p>
        </div>
        } }
      </div>
    </div>

    @if (initialized() && pagination() && data.rows && data.rows.length > 0) {
    <div class="crud-footer" @fadeIn>
      <mat-paginator
        [pageSizeOptions]="[10, 25, 50, 100]"
        [length]="data.total"
        [pageSize]="data.limit"
        aria-label="Selecciona pagina de placas"
        (page)="handlePage($event)"
      ></mat-paginator>
    </div>
    }
  </div>
</div>
